export default {
    lang: "荷兰语",
    application: {
        name: 'Informatiepublicatiesysteem',
    },
    ajaxTip: {
        success: 'Succes',
        error: 'Mislukt',
        noAccess: 'Geen toegang tot deze bron',
        notFound: 'Toegangsbijlage bestaat niet',
        serverBusy: 'Server is druk',
        timeOut: 'Timeout',
    },
    menu: {
        home: 'Startpagina',
        template: 'Sjabloonbeheer',
        program: 'Programmabeheer',
        playplan: 'Afspeelplan',
        device: 'Apparaatbeheer',
        "source-material": 'Materiaalbeheer',
        material: 'Materiaal',
        checkManage: 'Goedkeuringsbeheer',
        setting: 'Instellingen',
        usercenter: "Gebruikerscentrum",
        adminManage: "Apparaatbeheer",
        schedule: "Te doen-items",
        capitalassets: "Activa beheer",
        modifyPassword: "Wachtwoord wijzigen",
        logout: "Uitloggen",
        "add": "Toevoegen",
        "edit": "Bewerken",
        "delete": "Verwijderen",
        "view": "Bekijken",
        "menu_1": "Startpagina",
        "menu_2": "Apparaatbeheer",
        "menu_3": "Bewerken (Geavanceerde instellingen - Basisbewerking - Netwerk wijzigen)",
        "menu_4": "Onmiddellijke opdrachten",
        "menu_5": "Bewerken (Afdeling overbrengen)",
        "menu_6": "Strategie",
        "menu_7": "Volume-instellingen",
        "menu_8": "Helderheid-instellingen",
        "menu_9": "Downloadinstellingen",
        "menu_10": "Slaapinstellingen",
        "menu_11": "Apparaateigenschappen",
        "menu_12": "Bewerken/Toevoegen",
        "menu_13": "Programmabeheer",
        "menu_14": "Publicatiegeschiedenis",
        "menu_15": "Verwijderen (Batch/Individueel)",
        "menu_16": "Programma's in publicatie",
        "menu_17": "Groepering",
        "menu_19": "Programmalijst",
        "menu_20": "Inhoudsbewerking",
        "menu_21": "Programma kopiëren",
        "menu_23": "Programma publiceren",
        "menu_24": "Materiaalbeheer",
        "menu_25": "Uploaden",
        "menu_28": "Snelpublicatie",
        "menu_29": "Sjabloonbeheer",
        "menu_30": "Openbare sjablonen",
        "menu_31": "Nu gebruiken",
        "menu_32": "Mijn sjablonen",
        "menu_33": "Publiceren in openbare sjablonen",
        "menu_35": "Delen geschiedenis",
        "menu_36": "Auditbeheer",
        "menu_37": "Programma-audit",
        "menu_38": "Auditeren (Goedkeuren/Weigeren)",
        "menu_39": "Materiaal-audit",
        "menu_41": "Auditgeschiedenis (Operator)",
        "menu_42": "Auditgeschiedenis (Auditeur)",
        "menu_43": "Goedkeuringsaantal weergeven",
        "menu_44": "Organisatiebeheer",
        "menu_45": "Logbeheer",
        "menu_46": "Afspeellijsten",
        "menu_47": "Publicatielogs",
        "menu_48": "Foutlogs",
        "menu_49": "Operationslogs",
        "menu_50": "Bestandslogs",
        "menu_51": "Aanmeldlogs",
        "menu_52": "Inhoudsgoedkeuring",
        "menu_53": "Opslagruimte",
        "menu_54": "Organisatiestructuur",
        "menu_55": "Rolrechten",
        "menu_56": "Autorisatie",
        "menu_57": "Weergeven (Autorisatierechten)",
        "menu_58": "Organisatieleden",
        "menu_60": "Wachtwoorden van ondergeschikte gebruikers opnieuw instellen",
        "menu_61": "Activa beheer",
        "menu_62": "Mijn saldo",
        "menu_63": "Weergeven (Fondsdetails)",
        "menu_64": "Mijn dataverbruik",
        "menu_65": "Weergeven (Details dataverbruik)",
        "menu_66": "Dataverbruik kopen",
        "menu_67": "Mijn capaciteit",
        "menu_68": "Mijn apparaten",
        "menu_69": "Bestelgegevens",
        "menu_70": "Weergeven (Opladen)",
        "menu_71": "Weergeven (Gekochte sjablonen)",
        "menu_72": "Weergeven (Gekochte dataverbruik)",
        "menu_73": "Andere rechten",
        "menu_74": "Weergeven (Statistieken materialen en programma's)",
        "menu_75": "Weergeven (Activa)",
        "menu_76": "Weergeven (Cloud dataverbruik/Statistieken)",
        "menu_77": "Weergeven (Statistieken online apparaten)"
    },
    login: {
        terminalServiceSystem: 'Intelligente terminalservice systeem',
        accountLogin: 'Account inloggen',
        register: 'Registreren',
        accountLoginTip: 'Inloggen met bestaand account',
        scanQRCode: 'Scan de QR-code',
        readAndAgree: 'Ik heb gelezen en ga akkoord',
        readAndAgreeLink: 'Gebruikersserviceovereenkomst',
        readAndAgreeAgreement: 'Lees en ga akkoord met de gebruikersserviceovereenkomst',
        forgetpassword: "Wachtwoord vergeten?",
        resetpassword: "Wachtwoord opnieuw instellen",
        phoneEmptyTip: "Voer uw telefoonnummer in",
        nextStep: "Volgende stap",
        title: 'Welkom bij het inloggen',
        submit: 'Inloggen',
        userName: 'Account',
        password: 'Wachtwoord',
        userNameEmptyTip: 'Voer uw account in',
        passwordEmptyTip: 'Voer uw wachtwoord in',
        passwordFormatTip: 'Voer het juiste wachtwoordformaat in',
        passwordIsOk: 'Voer het bevestigingswachtwoord in',
        passwordSign: 'Voer uw wachtwoord in',
        codeTip: "Voer de verificatiecode in",
        phone: "Telefoonnummer mag niet leeg zijn",
        code: "Verificatiecode mag niet leeg zijn",
        nickname: "Bedrijfsnaam mag niet leeg zijn",
        pass: "Wachtwoord mag niet leeg zijn",
        pwdMessage: "Wachtwoordlengte 8~20 tekens, mag geen spaties bevatten en moet 3 van de volgende bevatten: hoofdletters, kleine letters, cijfers, speciale tekens",
        pwdMessage01: "Voer een wachtwoord in van minimaal acht tekens met letters en cijfers",
        pwdMessage02: "Wachtwoordlengte 8-20 tekens",
        pwdMessage03: "Wachtwoord mag geen spaties bevatten",
        pwdMessage04: "Wachtwoord moet 3 van de volgende bevatten: hoofdletters, kleine letters, cijfers, symbolen",
        newpassempty: "Nieuw wachtwoord mag niet leeg zijn",
        newpass: "De twee wachtwoorden komen niet overeen",
        getcode: "Verificatiecode opvragen",
        format: "Ongeldig telefoonnummerformaat",
        chongfa: "Herstellen na seconden",
        isSend: 'Verzonden',
        noregister: "Geen account? Registreer nu",
        Mobile: "Telefoonnummer",
        verificationcode: "Verificatiecode",
        petname: "Bijnaam",
        Quickregistration: "Snelle registratie",
        xiugaimima: "Wachtwoord wijzigen",
        jiumima: "Oud wachtwoord",
        xinmima: "Nieuw wachtwoord",
        zaicishuruxinmima: "Voer het nieuwe wachtwoord opnieuw in",
        xiugaichenggong: "Wijziging succesvol",
        xiugaishoujihao: "Telefoonnummer wijzigen",
        dengluzhanghao: "Inlogaccount",
        gongsiid: "Bedrijfs-ID",
        yonghunicheng: "Gebruikersbijnaam",
        chuangjianshijian: "Aanmaaktijd",
        gongsimingcheng: "Bedrijfsnaam",
        denglumima: "Inlogwachtwoord",
        jianyi: "Het wordt aanbevolen om een wachtwoord te gebruiken dat bestaat uit letters en cijfers",
        shezhimima: "Wachtwoord instellen",
        shezhishoujihao: "Telefoonnummer wijzigen/instellen",
        yibangding: "Verbonden",
        weibangding: "Niet verbonden",
        zhanghuanquan: "Accountveiligheid",
        yonghuxinxi: "Gebruikersinformatie",
        zhuceSucMsg: 'Gefeliciteerd, registratie succesvol!',
        verificationcodeSucMsg: "Verificatiecode succesvol verzonden！",
        requiredIsEmpty: "Verplichte velden mogen niet leeg zijn！",
        emailObj: {
            title: 'E-mail',
            tit: 'Inloggen met e-mail',
            tip: 'Voer uw e-mailadres in',
            formatTip: 'Voer een geldig e-mailadres in',
        },
        phoneObj: {
            title: 'Telefoonnummer',
            tit: 'Inloggen met telefoon',
            tip: 'Voer uw telefoonnummer in',
            formatTip: 'Voer een geldig telefoonnummer in',
        },
        emailOrPhoneObj: {
            title: 'E-mail of telefoonnummer',
            tit: 'Inloggen met e-mail of telefoonnummer',
            tip: 'Voer uw e-mail of telefoonnummer in',
            formatTip: 'Voer een geldig e-mail- of telefoonnummer in',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'Inloggen met WeChat',
        },
        googleObj: {
            title: 'Google',
            tit: 'Inloggen met Google',
        },
        confirm: 'Bevestigen',
        confirmSubmit: 'Indienen bevestigen',
        cancel: 'Annuleren',
        close: 'Sluiten',
        bindSucMsg: 'Binding succesvol',
        toContinueBindAccount: 'Doorgaan om de binding van derdaccounts te voltooien',
        bindTip01: 'Geen account? Registreer er een',
        bindTip02: 'Bestaand account',
        bindTip03: 'Het huidige derdaccount is niet gebonden aan een platformaccount. Bind een bestaand account of registreer en bind een nieuw account om de volgende keer snel in te loggen.',
        bindTip04: 'Bestaand account binden',
        bindTip05: 'Nieuw account registreren en binden',
        bindTip06: 'U heeft zich geautoriseerd via een derde partij, vul de volgende inloggegevens in om de binding te voltooien',
        bindSubmit: 'Binding indienen',
        enterAccountTip: 'Voer de accountnaam in',
        RegisterAndBind: 'Registreren en binden',
        loginErr: 'Gebruikersnaam of wachtwoord onjuist！',
        usercenter: "Gebruikerscentrum",
        pleaseInputName: "Voer een naam in",
        operationSuccess: "Operatie succesvol！",
        edit: "Bewerken",
        xiugai: "Wijzigen",
        userData: "Persoonlijke gegevens",
        changePassword: "Wachtwoord wijzigen",
        account: "Account",
        userName01: "Gebruikersnaam",
        phoneNumber: "Telefoonnummer",
        role: "Rol",
        createTime: "Aanmaaktijd",
        genghuang: "Vervangen",
        bangding: "Binden",
        unbind: "Ontbinden",
        plesaseSelectBindingType: "Selecteer het bindingstype",
        pleaseConfirmCont: "Bevestig dat ik deze inhoud heb gelezen",
        confirmReadCont: "Ik heb deze inhoud gelezen",
        frequentTip: "Te veel bewerkingen, probeer het later opnieuw!",
        zhuxiaoBtn: "Account opzeggen",
        zhuxiaoTitle: "Account opzegging",
        querenZhuxiao: "Opzegging bevestigen",
        jiXu: "Doorgaan",
        sendCodeBtn: "Verificatiecode verzenden",
        passwordIsNotOldPassword: "Bevestigingswachtwoord verschilt van het nieuwe wachtwoord",
        passwordIsOldPassword: "Het gewijzigde wachtwoord is hetzelfde als het oude wachtwoord",
        passFormatError: "Voer het juiste wachtwoordformaat in",
        oldPassWord: "Oud wachtwoord",
        newPassWord: "Nieuw wachtwoord",
        inputPlaceholder: 'Voer in',
        confirmPassword: "Wachtwoord bevestigen",
        zhuxiaoTip: `
            1. Het opzeggen van een account is onomkeerbaar. Zodra het account is opgezegd, kunt u zich niet meer aanmelden en dit account of derdaccounts die via dit account zijn geregistreerd en aangemeld, niet gebruiken. Maak zelf een back-up van accountgerelateerde informatie en gegevens.
            2. Voordat u dit account registreert, moet u ervoor zorgen dat alle activa zijn leeggemaakt en er geen geschillen bestaan; zodra dit account is opgezegd, wordt ervan uitgegaan dat u het eigendom van alle activa en rechten in dit account opzegt, en deze kunnen niet worden hersteld of teruggevonden.
            3. Als een telefoonnummer dat is gebruikt voor het registreren van accounts, cumulatief 3 keer is opgezegd, kan dit telefoonnummer geen nieuwe accounts meer registreren en kan het ook niet aan andere accounts worden gebonden.
        `
    },
    home: {
        title: "Startpagina",
        quickOperation: "Snelle bewerkingen",
        addDevice: "Apparaat toevoegen",
        publishProgram: "Programma publiceren",
        publishMaterial: "Materiaal publiceren",
        makeProgram: "Programma maken",
        uploadMaterial: "Materiaal uploaden",
        todayData: "Vandaag gegevens (elke uur bijgewerkt)",
        playNumChart: "Statistieken van het aantal afspeelingen",
        deviceOnlineStatus: "Online status van apparaten",
        onLineDevice: "Online apparaten",
        unLineDevice: "Offline apparaten",
        programPlayTime: "Statistieken van de afspeeltijd van programma's",
        downloadSoft: "Software downloaden",
        adminApp: "Mobiele gebruikersclient",
        playerApp: "Informatiepublicatie afspeelterminal",
        downloadAdminApp: "Klik om de gebruikersclient te downloaden",
        downloadPlayerApp: "Klik om de afspeelclient te downloaden",
        aboutUs: "Over ons",
        userManual: "Gebruikershandleiding",
        message: "Ik wil een bericht achterlaten",
    },
    device: {
        inputPlaceholder: 'Voer in',
        selectPlaceholder: 'Selecteer',
        osTypeStr: 'Terminalbesturingssysteem',
        onLineStatus: 'Online status',
        dpi: 'Resolutie',
        companyDeptIdName: 'Toegewezen organisatie',
        deviceGroupIdName: 'Toegewezen groep',
        editOrMove: 'Bewerken/Verenigen',
        loanOriginationFee: 'Leningkosten',
        strategyInfoLook: 'Strategie-informatie weergeven',
        programLook: 'Programma weergeven',
        addEquipments: 'Apparaten toevoegen',
        luminanceSet: 'Helderheid regelen',
        terminal: 'Terminaalinstellingen',
        transferCompany: 'Afdeling overzetten',
        releasedProgram: 'Programma publiceren',
        screenshot: 'Schermafbeelding',
        changeGroup: 'Groep wijzigen',
        defaultGroup: "Standaardgroep",
        operation: "Bewerking",
        edit: "Bewerken",
        saveEdit: "Bewerking opslaan",
        add: "Toevoegen",
        save: "Opslaan",
        setting: "Instellingen",
        program: "Programma",
        unbind: "Ontbinden",
        sleep: "Slapen",
        wakeup: "Ontwaken",
        restart: "Herstarten",
        shutdown: "Uitschakelen",
        reportLog: "Logboek rapporteren",
        clearPlayData: "Afspeelterminalgegevens wissen",
        offlineWarn: "Dit apparaat is offline, probeer het opnieuw nadat het apparaat online is！",
        confirmUnbind: "Ontbinden bevestigen",
        confirmReset: "Wissen bevestigen",
        confirmDelete: "Verwijderen bevestigen",
        delete: "Verwijderen",
        cancelDelete: "Verwijderen annuleren",
        confirmResetSuccess: "Wissen succesvol",
        confirm: "Bevestigen",
        cancel: "Annuleren",
        operationSuccess: "Bewerking succesvol",
        unbindSuccess: "Ontbinden succesvol",
        pleaseSelectDevice: "Selecteer een apparaat",
        pleaseSelectOnlineDevice: "Selecteer een online apparaat",
        confirmMixOperation: "De geselecteerde apparaten bevatten offline apparaten, deze instelling is niet van toepassing op offline apparaten, doorgaan bevestigen？",
        pleaseSelectDate: "Selecteer een datum",
        reportSuccess: "Rapporteren succesvol",
        deviceSetting: "Apparaatinstellingen",
        default: "Standaard",
        all: "Alles",
        deviceList: "Apparaatlijst",
        addDevice: "Apparaat toevoegen",
        department: "Afdelingsorganisatie",
        deviceType: "Resolutie",
        osType: "Terminalbesturingssysteem",
        onlineState: "Online status",
        online: "Online",
        offline: "Offline",
        notActive: "Niet geactiveerd",
        search: "Voer trefwoorden in",
        batchOperation: "Batchbewerking",
        allDevices: "Alle apparaten",
        deviceAttribute: "Apparaatkenmerken",
        selectReportDate: "Rapportagedatum selecteren",
        inputName: "Voer een naam in",
        inputWidth: "Voer de breedte in",
        inputHeight: "Voer de hoogte in",
        inputResolutionRatio: "Voer een geheel getal groter dan 0 in！",
        inputSort: "Voer de sortering in",
        serialNum: "Volgnummer",
        name: "Naam",
        width: "Breedte",
        height: "Hoogte",
        resolutionRatio: "Resolutie",
        inputResolutionRatioName: "Voer de resolutienaam in",
        sort: "Sortering",
        personal: "Persoonlijk",
        system: "Systeem",
        type: "Type",
        systemDefaultSettingUneditable: "Standaardsysteeminstellingen kunnen niet worden bewerkt!",
        systemDefaultSettingUnDeletable: "Standaardsysteeminstellingen kunnen niet worden verwijderd!",
        newz: "Toevoegen",
        total: "Totaal",
        totalNum: "items",
        strategyName: "Strategienaam",
        associatedTerminalNum: "Aantal gekoppelde terminals",
        createTime: "Aanmaaktijd",
        pleaseSelectStrategy: "Selecteer een strategie！",
        onlySelectOneData: "Alleen één gegevensrecord selecteren！",
        downloadStrategy: "Strategie downloaden",
        inputStrategyName: "Voer de strategienaam in",
        luminanceControl: "Helderheid regelen",
        volumeStrategy: "Volume strategie",
        saveSuccess: "Opslaan succesvol",
        screenAngle: "Schermrotatie (°)",
        startTime: "Begintijd",
        endTime: "Eindtijd",
        repeat: "Herhalen",
        monday: "Maandag",
        tuesday: "Dinsdag",
        wednesday: "Woensdag",
        thursday: "Donderdag",
        friday: "Vrijdag",
        saturday: "Zaterdag",
        sunday: "Zondag",
        everyday: "Elke dag",
        downloadSpeed: "Downloadsnelheid",
        inputDownloadSpeed: "Voer de downloadsnelheid in",
        operator: "Bewerking",
        pleaseSelectDeleteData: "Selecteer de te verwijderen gegevens！",
        confirmBatchDelete: "Batchverwijdering bevestigen？",
        pleaseInputName: "Voer een naam in",
        detailSetting: "Gedetailleerde instellingen",
        weekPlan: "Weekplan",
        specialDateSetting: "Speciale datuminstellingen",
        weekdayInfo: "Weekdag is een verplichte keuze!",
        volumeInfo: "Volume is een verplichte keuze!",
        timeError: "Tijdkeuze onjuist!",
        editSuccess: "Bewerking succesvol！",
        addSuccess: "Toevoeging succesvol！",
        addSpecialPlan: "Speciaal strategieplan toevoegen",
        downloadSpeedInfo: "Downloadsnelheid: (0 betekent downloaden verbieden)",
        pleaseSelectStartTime: "Selecteer de begintijd",
        pleaseSelectEndTime: "Selecteer de eindtijd",
        luminanceError: "Voer een geldig helderheidswaarde in！",
        defaultLuminance: "Standaard helderheid",
        luminance: "Helderheid",
        defaultLuminanceInfo: "Standaard helderheid (100 betekent het helderste, 0 betekent het donkerste)",
        volume: "Volume",
        saveLuminance: "Helderheid opslaan",
        changeSuccess: "Wijziging succesvol！",
        changeNetwork: "Netwerk wijzigen",
        netName: "Netwerknaam",
        nameempty: "Netwerknaam mag niet leeg zijn",
        currentNetwork: "Huidig netwerk",
        ipAddress: "IP-adres",
        dailyMode: "Dagelijks mode",
        weeklyMode: "Wekelijks mode",
        turnOnTime: "Inzettingstijd",
        turnOffTime: "Uitzettingstijd",
        startSleep: "Slapen beginnen",
        endSleep: "Slapen eindigen",
        batchDelInfo: "Geselecteerde items verwijderen bevestigen？",
        timeCannotBeEmpty: "Tijd mag niet leeg zijn!",
        startUp: "Inzetten",
        shutDown: "Uitzetten",
        volumeSize: "Volume",
        defaultVolume: "Standaard volume (100 betekent het maximale, 0 betekent dempen)",
        chooseStartTime: "Selecteer de begintijd",
        chooseEndTime: "Selecteer de eindtijd",
        saveVolume: "Volume opslaan",
        screenRotationUnSaved: "Schermrotatie niet opgeslagen",
        volumeSettingUnSaved: "Volume-instelling niet opgeslagen",
        luminanceSettingUnSaved: "Helderheidsinstelling niet opgeslagen",
        confirmClosePopup: "Dit pop-upvenster sluiten bevestigen?",
        volumeSettingSuccess: "Volume wijziging succesvol",
        luminanceSettingSuccess: "Helderheid wijziging succesvol",
        advancedSettingUnSaved: "Geavanceerde instellingen niet opgeslagen",
        settingTitle: "Terminaalinstellingen",
        volumeSetting: "Volume-instelling",
        luminanceSetting: "Helderheidsinstelling",
        downloadSetting: "Downloadinstelling",
        sleepSetting: "Slapende instelling",
        onOffSetting: "Gestructureerde in-/uitschakeling",
        screenRotation: "Schermrotatie",
        namingError: "Naamfout, de bestandsnaam mag geen spaties bevatten！",
        deleteSuccess: "Verwijdering succesvol",
        deleteFolder: "Map verwijderen",
        pleaseInputDeviceName: "Voer de apparaatnaam in",
        pleaseInputDeviceId: "Voer de apparaat-ID in",
        discoverDevice: "Apparaat ontdekken",
        deviceId: "Apparaat-ID",
        bound: "Verbonden",
        bind: "Binden",
        noDevice: "Geen apparaten",
        refresh: "Verversen",
        manualAdd: "Handmatig toevoegen",
        deviceGroup: "Apparaatcategorie",
        pleaseSelectGroup: "Selecteer een groep！",
        deviceName: "Apparaatnaam",
        goAdd: "Naar toevoegen gaan",
        close: "Sluiten",
        bindCountInsufficient: "Onvoldoende bindbare hoeveelheid, werk het aantal apparaten bij voordat u toevoegt！",
        displayNumber: "Weergavenummer",
        groupName: "Groepsnaam",
        pleaseSelectGroupName: "Vul de groepsnaam in！",
        moveGroup: "Groep verplaatsen",
        longitude: "Lengtegraad",
        latitude: "Breedtegraad",
        nationality: "Nationaliteit",
        province: "Provincie",
        city: "Stad",
        county: "Distrikt",
        outNetIp: "Extern netwerk IP",
        inNetIp: "Intern netwerk IP",
        companyName: "Bedrijfsnaam",
        Info: "Details",
        android: "Android",
        win: "Windows",
        osVersion: "Besturingssysteemversie",
        softwareVersion: "Softwareversie",
        diskSize: "Schijfgrootte",
        useSize: "Gebruikte grootte",
        macAddr: "MAC-adres",
        longitudeLatitudeInfo: "Lengte- en breedtegraden moeten tegelijk leeg of niet leeg zijn!",
        terminalName: "Terminalnaam",
        terminalGroup: "Terminalgroep",
        reportJournal: "Rapporteren of niet",
        systemVersion: "Besturingssysteemversie",
        storageSpace: "Opslagruimte",
        resolution: "Resolutie",
        runningMemory: "Werkgeheugen",
        model: "Model",
        registerStatus: "Registratiestatus",
        password: "Wachtwoord",
        passwordInfo: "Voer 6 tot 18 letters of cijfers in!",
        group: "Groep",
        address: "Adres",
        remark: "Opmerking",
        renewalPeriod: "Vervaltermijn",
        money: "Kosten",
        latitudeInfo: "Voer een geldige breedtegraad in!",
        totalPayment: "Totale bedrag",
        longitudeInfo: "Voer een geldige lengtegraad in!",
        setMeal: "Pakket",
        number: "Aantal",
        programName: "Programmanaam",
        playStatus: "Afspeelstatus",
        playType: "Afspeelwijze",
        play: "Afspeelen",
        pause: "Pauzeren",
        playTime: "Afspeeltijd",
        programDeleted: "Programma verwijderd",
        playSuccess: "Programma gepland voor afspelen",
        pauseSuccess: "Pauzeren succesvol",
        playCycle: "Doorlopend afspelen",
        playInsert: "Invoegen afspelen",
        withdrawSuccess: "Terugroepen succesvol",
        withdrawInfo: "Selecteer eerst het te terugroepen programma！",
        programBelong: "Toegewezen programma",
        checkAll: "Alles selecteren",
        batchDel: "Batch verwijderen",
        delConfirm: "Geselecteerde items verwijderen bevestigen？",
        check: "Geselecteerd",
        noProgram: "Geen programma's",
        details: "Details",
        screenshotFail: "Schermafbeelding mislukt",
        policyName: "Strategienaam",
        terminalNum: "Aantal gekoppelde terminals",
        powerStrategy: "Voedingsstrategie",
        pleaseSelectDepartment: "Selecteer een afdeling！",
        screenshotControl: "Schermafbeeldingsbesturing",
        未激活: "Niet geactiveerd",
        已激活: "Geactiveerd",
        未绑定: "Niet verbonden",
        已绑定: "Verbonden",
    },
    programManage: {
        programList: "Programmalijst",
        publishProgram: "Programma publicatie traceerbaarheid",
        week1: "Maandag",
        week2: "Dinsdag",
        week3: "Woensdag",
        week4: "Donderdag",
        week5: "Vrijdag",
        week6: "Zaterdag",
        week7: "Zondag",
        monday: "Maandag",
        tuesday: "Dinsdag",
        wednesday: "Woensdag",
        thursday: "Donderdag",
        friday: "Vrijdag",
        saturday: "Zaterdag",
        sunday: "Zondag",
        name: "Naam",
        preview: "Voorbeeld",
        playDeviceNum: "Aantal afspeelapparaten",
        copyDeviceCode: "Klik om te kopiëren",
        osType: "Besturingssysteemtype",
        playDate: "Afspeeldatum",
        playWeek: "Afspeelweek",
        everyday: "Elke dag",
        start: "Van",
        end: "Tot",
        playOperateStatusStr: "Publicatiestatus",
        playDevice: "Afspeelapparaat",
        downloadView: "Downloaden en bekijken",
        publisher: "Uitgever",
        publishTime: "Publicatietijd",
        operation: "Bewerking",
        add: "Toevoegen",
        groupName: "Groepsnaam",
        selectDevice: "Terminal selecteren",
        searchDevice: "Terminal zoeken",
        pleaseFillGroupName: "Vul de groepsnaam in！",
        remarkInfo: "Opmerking",
        compile: "Bewerken",
        withdrawConfirm: "Dit programma terugroepen bevestigen？",
        confirm: "Bevestigen",
        cancel: "Annuleren",
        withdraw: "Terugroepen",
        batchWithdraw: "Batch terugroepen",
        batchPublish: "Batch publiceren",
        batchDelete: "Batch verwijderen",
        batchOperation: "Batchbewerking",
        notUse: "Niet gebruikt",
        notChecked: "Niet goedgekeurd",
        notPass: "Niet goedgekeurd",
        delete: "Verwijderen",
        publishTextLeft: "Gepubliceerd",
        offTextLeft: "Gepauzeerd",
        pleaseSelectProgramToMove: "Selecteer het te verplaatsen programma！",
        pause: "Pauzeren",
        pauseConfirm: "Pauzeren bevestigen？",
        play: "Afspeelen",
        downloadUdisk: "USB-stick downloaden",
        deviceList: "Apparaatlijst",
        groupSelection: "Groepselectie",
        operationSuccess: "Bewerking succesvol",
        deleteSuccess: "Verwijdering succesvol",
        selectDate: "Datum selecteren",
        publishStatus: "Publicatiestatus",
        checkStatus: "Goedkeuringsstatus",
        waitAuditing: "In behandeling",
        auditPass: "Goedgekeurd",
        auditRefuse: "Afgewezen",
        all: "Alles",
        playStatus: "Afspeelstatus",
        playStatust: "Afspeelstatus",
        pauseStatus: "Gepauzeerd",
        notStartStatus: "Niet begonnen",
        resolutionratio: "Resolutie",
        totalNum: "items",
        programName: "Programmanaam",
        playStartTime: "Begintijd van afspelen",
        playEndTime: "Eindtijd van afspelen",
        createTime: "Aanmaaktijd",
        nationality: "Nationaliteit",
        province: "Provincie",
        city: "Stad",
        county: "Distrikt",
        address: "Adres",
        ip: "IP-adres",
        location: "Locatie",
        log: "Logboek",
        pleaseFillProgramName: "Vul de programmanaam in！",
        selectGroup: "Groep selecteren",
        startTime: "Begintijd",
        endTime: "Eindtijd",
        publishCycle: "Publicatiecyclus",
        publishDeviceNum: "Aantal gepubliceerde apparaten",
        pleaseSelectRecord: "Selecteer een record",
        deviceName: "Terminalnaam",
        deviceId: "Terminalapparaat-ID",
        deviceGroupIdName: "Toegewezen groep",
        notClassified: "Niet geclassificeerd",
        osTypeStr: "Terminalbesturingssysteem",
        storageSpace: "Opslagruimte",
        onLineStatus: "Online status",
        onLine: "Online",
        offLine: "Offline",
        sleep: "Slapen",
        unknown: "Onbekend",
        registerStatus: "Registratiestatus",
        trialPeriod: "Proefperiode",
        notActive: "Niet geactiveerd",
        active: "Geactiveerd",
        parameterError: "Parameters onjuist!",
        pleaseSelectProgram: "Selecteer een programma!",
        pleaseSelectProgramEdit: "Selecteer het te bewerken programma!",
        confirmWithdrawSelectedProgram: "Geselecteerde programma's terugroepen bevestigen？",
        withdrawSuccess: "Terugroepen succesvol",
        allPrograms: "Alle programma's",
        defaultGroup: "Standaardgroep",
        cannotShareEmptyProgram: "Kan geen leeg programma delen！",
        onlyShareYourProgram: "U kunt alleen programma's delen die u hebt gemaakt!",
        pleaseSelectProgramEditPublishTime: "Selecteer het programma waarvoor de publicatietijd is bewerkt!",
        pleaseSelectDevice: "Selecteer een apparaat!",
        programDetail: "Programmadetails",
        errorReason: "Foutreden",
        availableStorageSpaceInsufficient: "Onvoldoende beschikbare opslagruimte",
        partialDeviceReleaseFailure: "Publicatie mislukt voor sommige apparaten",
        allDeviceReleaseSuccess: "Publicatie succesvol voor alle apparaten",
        partialDeviceReleaseSuccess: "Publicatie succesvol voor sommige apparaten",
        allGroup: "Alle groepen",
        allProgram: "Alle programma's",
        unGrouped: "Niet gegroepeerd",
        replaceProgram: "Programma vervangen",
        replaceProgramTip: "Het nieuw gepubliceerde programma zal de oorspronkelijke uitgezonden programmagegevens op de afspeelterminal vervangen！",
        screen: "Enkel/ dubbel scherm",
        singleScreen: "Enkel scherm",
        doubleScreen: "Dubbel scherm",
        playSetting: "Afspeelinstellingen",
        batchPlaySetting: "Batch instellen van afspeeltijd",
        individualPlaySetting: "Afzonderlijk instellen van afspeeltijd",
        playTime: "Afspeeltijd",
        daily: "Elke dag",
        weekdays: "Maandag tot vrijdag",
        monthly: "Deze maand",
        advancedSetting: "Geavanceerde instellingen",
        playProgram: "Programma afspelen",
        searchProgram: "Voer trefwoorden in",
        shareAddressNotExist: "De linkadres bestaat niet, probeer het opnieuw",
        copySuccess: "Kopiëren succesvol",
        shareLink: "Delen link",
        publish: "Publiceren",
        noResource: "Geen bronnen",
        single: "Enkel scherm",
        double: "Dubbel scherm",
        time: "Tijd",
        associatedTerminalNum: "Aantal gekoppelde terminals",
        default: "Standaard",
        moveGroup: "Groep verplaatsen",
        pleaseSelectGroup: "Vul de groepsnaam in！",
        copy: "Kopiëren",
        FUBEN: "Kopie",
        nameempty: "Naam mag niet leeg zijn",
        whitespace: "Naamfout, de bestandsnaam mag geen spaties bevatten！",
        programWhitespace: "Naamfout, de programmanaam mag geen spaties bevatten！",
        pleaseSelectResolution: "Selecteer een resolutie！",
        dataError: "Gegevens onjuist！",
        createProgram: "Nieuw programma maken",
        directCreate: "Direct maken",
        myTemplate: "Mijn sjablonen",
        use: "Gebruiken",
        free: "Gratis",
        loadMore: "Meer laden",
        confirmDelete: "Verwijderen bevestigen",
        deleteGroup: "Groep verwijderen",
        notPublished: "Niet gepubliceerd",
        notPassed: "Niet goedgekeurd",
        notUsed: "Niet gebruikt",
        confirmDeleteSelectedProgram: "Geselecteerde programma's verwijderen bevestigen？",
        companyName: "Bedrijfsnaam",
        programCannotDownload: "Dit programma kan niet worden gedownload！",
        publishMaterial: "Materiaal publiceren",
        playMaterial: "Materiaal afspelen",
        pleaseInputMaterialName: "Voer de materiaalnaam in",
        size: "Grootte",
        pleaseInputDeviceName: "Voer de apparaatnaam in",
        item: "items",
        allMaterial: "Al materiaal",
        allDevices: "Alle apparaten",
        "saveSuccess": "Succesvol opgeslagen",
        "savefaill": "Opslaan mislukt",
        "playMode": "Afspeelmodus",
        "cyclePlay": "Cyclische afspeeling",
        "insertPlay": "Ingesloten afspeeling",
        "noData": "Geen gegevens beschikbaar",
        "Add": "Toevoegen",
        "replace": "Vervangen",
        "repeat": "Herhalen",
        "start01": "Start",
        "end01": "Eind",
        "startDate": "Begindatum",
        "endDate": "Einddatum",
        "useNow": "Onmiddellijk gebruiken",
        "fillStartEndTimeFirst": "Vul eerst de start- en eindtijd in voordat u toevoegt",
        "fillFullPlayTime": "Vul de volledige afspeeltijd in",
        "fillCorrectPlayTime": "Vul de juiste afspeelperiode in",
        "sDateAndEDateBothEmptyOrFilled": "De begindatum en einddatum moeten beide leeg of beide ingevuld zijn"
    },
    source: {
        addResource: "Bron toevoegen",
        width: "Breedte",
        height: "Hoogte",
        size: "Grootte (KB)",
        name: "Naam",
        pleaseInputResourceName: "Voer de bronnaam in！",
        addToGroup: "Toevoegen aan groep",
        remark: "Opmerking",
        promptFgIllustrate: "Illustratie",
        promptFgRealisticPhoto: "Realistische foto",
        promptFgSimplisticDrawing: "Simpele tekening",
        promptFgChineseStyle: "Chinese stijl",
        promptFgPixelArt: "Pixel stijl",
        noModel: "Geen modellen beschikbaar, neem contact op met de beheerder！",
        getModelFailed: "Ophalen van model mislukt, probeer het later opnieuw！Of neem contact op met de beheerder！",
        createImagePrompt: "Afbeelding wordt gegenereerd, sluit dit venster later！",
        promptEmpty: "Voer een prompt in",
        dpiEmpty: "Selecteer een afbeeldingsverhouding！",
        fgEmpty: "Selecteer een stijl！",
        style: "Stijl",
        idEmpty: "Afbeeldings-ID mag niet leeg zijn",
        exist: "Deze afbeelding bestaat al in het materiaal",
        addSuccess: "Materiaal toevoegen succesvol",
        saveError: "Opslaan van afbeelding mislukt, probeer het later opnieuw！",
        delSuccess: "Verwijderen succesvol",
        generateImage: "Tekst naar afbeelding",
        generateImagePlaceholder: 'Voer de afbeelding in die u wilt genereren, bv: een vlinder die dansend tussen bloemen zweeft',
        aiExpand: "Intelligente uitbreiding",
        negativePrompt: "Negatieve prompt",
        negativePromptTooltip: "Wordt gebruikt om inhoud of kenmerken duidelijk uit te sluiten die de gebruiker niet in de uitvoer wil zien",
        imageRatio: "Afbeeldingsverhouding",
        generateImageBtn: "Onmiddellijk genereren",
        shengchengjieguo: "Generatieresultaat",
        generateImageLoadingTip: "Genereren, klik niet opnieuw of sluit dit venster...",
        Tooltip: "Breng uw creativiteit tot leven met AI",
        saveToMaterial: "Opslaan in materiaal",
        publish: "Onmiddellijk publiceren",
        download: "Downloaden",
        generateHistory: "Generatiegeschiedenis",
        hide: "Inklappen",
        cancel: "Annuleren",
        useExpand: "Uitbreiding gebruiken",
        all: "Alles",
        delete: "Verwijderen",
        loadMore: "Meer laden",
        aiTip: "Inhoud wordt gegenereerd door een kunstmatige intelligentiemodel en vertegenwoordigt niet het standpunt, de positie of de houding van het platform. Gebruik AI-inhoud op een redelijke en conform wijze",
        operationSuccess: "Bewerking succesvol",
        moveGroup: "Groep verplaatsen",
        groupName: "Groepsnaam",
        pleaseSelectGroup: "Selecteer de groepsnaam！",
        shenhe: "Goedkeuren",
        shenheStatus: "Goedkeuringsstatus",
        shenheSuccess: "Goedgekeurd",
        shenheRefuse: "Afgewezen",
        pleaseSelectShenheStatus: "Selecteer de goedkeuringsstatus！",
        shenheRemark: "Goedkeuringsopmerking",
        pleaseInputShenheRemark: "Voer de goedkeuringsopmerking in！",
        pleaseInputFileName: "Voer de bestandsnaam in！",
        whitespace: "Naamfout, de bestandsnaam mag geen spaties bevatten！",
        dataError: "Gegevens onjuist！",
        confirmDelete: "Verwijderen bevestigen",
        confirm: "Bevestigen",
        deleteFolder: "Map verwijderen",
        add: "Toevoegen",
        edit: "Bewerken",
        fileName: "Bestandsnaam",
        group: "Groep",
        resolution: "Resolutie",
        type: "Type",
        image: "Afbeelding",
        music: "Muziek",
        video: "Video",
        uploadTime: "Uploadtijd",
        uploadUser: "Uploader",
        checkTime: "Goedkeuringstijd",
        checkUser: "Goedkeurer",
    },
    setting: {
        nameempty: "Naam mag niet leeg zijn",
        heightempty: "Hoogte mag niet leeg zijn",
        widthempty: "Breedte mag niet leeg zijn",
        resolutionratio: "Resolutie",
        name: "Naam",
        opteration: "Bewerking",
        compile: "Bewerken",
        delete: "Verwijderen",
        newz: "Toevoegen",
        compileratio: "Resolutie bewerken",
        sheizhifenbianlvmingcheng: "Resolutienaam instellen",
        shezhigaodu: "Hoogte instellen",
        shezhikuandu: "Breedte instellen",
        xinzengfenbianlv: "Nieuwe resolutie toevoegen",
        bianma: "Codering",
        bianjizhongduanmingcheng: "Terminalnaam bewerken",
        xinzengzhongduan: "Nieuwe terminal toevoegen",
        selectPrimaryColor: 'Hoofdkleur selecteren',
        fullScreen: 'Volledig scherm',
        exitFullScreen: 'Volledig scherm verlaten',
    },
    tabs: {
        refresh: 'Verversen',
        refreshAll: 'Alles verversen',
        close: 'Sluiten',
        closeOthers: 'Andere sluiten',
        closeAll: 'Alles sluiten',
        closeLeft: 'Linkerzijde sluiten',
        closeRight: 'Rechterzijde sluiten',
    },
    errorPage: {
        needLogin: 'U bent nog niet ingelogd！',
        pageNotFound: 'De pagina die u bezoekt bestaat niet！',
        redirectTo: 'Omleiden naar',
        orReturn: 'Of terugkeren naar',
        previousStep: 'Vorige stap',
    },
    headerUs: {
        systemNotice: "Systeemnotificatie",
        allNotices: "Alle notificaties",
        viewAllMessages: "Alle berichten weergeven",
        contactUs: "Contact met ons",
        operationSuccess: "Bewerking succesvol！",
        leaveMessage: "Ik wil een bericht achterlaten",
        messageTitle: "Titel",
        messageTitleTip: "Voer een titel in！",
        messageContentTip: "Maximaal 150 tekens",
        submit: "Indienen",
        markAsRead: "Als gelezen markeren",
        success: "Bewerking succesvol！"
    },
    material: {
        allMaterial: "Al materiaal",
        defaultGroup: "Standaardgroep",
        auditStatus: "Goedkeuringsstatus",
        auditPassed: "Goedgekeurd",
        auditRejected: "Afgewezen",
        pendingAudit: "In behandeling",
        all: "Alles",
        operateSuccess: "Bewerking succesvol！",
        pleaseSelectMaterial: "Selecteer materiaal！",
        moveGroup: "Groep verplaatsen",
        pleaseSelectGroup: "Selecteer een groep！",
        batchPublish: "Batch publiceren",
        batchRecall: "Batch terugroepen",
        batchDelete: "Batch verwijderen",
        materialList: "Materiaal lijst",
        uploadMaterial: "Materiaal uploaden",
        materialType: "Materiaaltype",
        pleaseInputMaterialName: "Voer de materiaalnaam in",
        selectAll: "Alles selecteren",
        confirmDeleteSelectedMaterial: "Geselecteerd materiaal verwijderen bevestigen？",
        deleteSuccess: "Verwijderen succesvol",
        delete: "Verwijderen",
        publish: "Publiceren",
        recall: "Terugroepen",
        confirmRecallSelectedMaterial: "Geselecteerd materiaal terugroepen bevestigen？",
        pleaseSelectMaterialGroup: "Selecteer de materiaalgroep！",
        recallSuccess: "Terugroepen succesvol",
        publishSuccess: "Publiceren succesvol",
        batchOperate: "Batchbewerking",
        item: "items",
        confirmDelete: "Verwijderen bevestigen？",
        edit: "Bewerken",
        confirmRecall: "Terugroepen bevestigen？",
        unaudited: "Niet goedgekeurd",
        notPassed: "Niet goedgekeurd",
        operate: "Bewerking",
        resolution: "Resolutie",
        none: "Geen",
        confirm: 'Bevestigen',
        cancel: 'Annuleren',
        AICreation: "AI creatie",
    },
    uploadFile: {
        operationSuccess: "Bewerking succesvol",
        uploadFile: "Uploadbeheer",
        uploadSuccess: "Uploaden succesvol",
        uploadCompleted: "Uploaden voltooid",
        uploadFail: "Uploaden mislukt",
        ConversionFailed: "Conversie mislukt！",
        loading: "Bezig met laden...",
        beQueuing: "In wachtrij...",
        Uploading: "Uploaden...",
        ConversionIng: "Conversie...",
        ConventionalResources: "Conventionele bronnen",
        DocumentResources: "Documentbronnen",
        complete: "Voltooid",
        upload: "Uploaden",
        fileSizeWraning01: "Materiaal grootte overschrijdt",
        fileSizeWraning02: "Wijzig het en upload opnieuw！",
        fileIsEmpty: "Bestand is leeg",
        uploadFileTip: "Niet ondersteund bestandsformaat",
        unablePreview: "Niet succesvol toegevoegd aan de materiaalbibliotheek, voorbeeld niet mogelijk",
        confirmDelete: "Verwijderen bevestigen？",
        deleteSuccess: "Verwijderen succesvol",
        delete: "Verwijderen",
        confirm: "Bevestigen",
        preview: "Voorbeeld",
        close: "Sluiten",
        cancel: "Annuleren",
        fileType: "Bestandstype",
        fileSize: "Bestandsgrootte",
        conversionProgress: "Conversievoortgang",
        progress: "Voortgang",
        image: "Afbeelding",
        video: "Video",
        audio: "Muziek",
        limitTip01: "一次上传",
        limitTip02: "bestanden per keer",
        okTip: "Materiaal wordt geüpload, sluit dit venster later！",
        usableSize: 'Beschikbare capaciteit',
        sizeUnableTip: "Onvoldoende beschikbare opslagruimte, wis ongebruikt materiaal om ruimte te besparen of neem contact op met de distributeur om de capaciteit van de cloudopslagruimte uit te breiden.",
        view: "Details weergeven",
        fileName: "Bestandsnaam",
    },
    template: {
        inputPlaceholder: 'Voer in',
        selectPlaceholder: 'Selecteer',
        noAuths: "Geen rechten, neem contact op met de beheerder",
        operationSuccess: "Bewerking succesvol",
        total: "Totaal",
        totalNum: "items",
        dan: "Enkel",
        shaung: "Dubbel",
        pleaseSelectGroup: "Selecteer een groep",
        preview: "Voorbeeld",
        free: "Gratis",
        use: "Gebruiken",
        dpi: 'Resolutie',
        delete: "Verwijderen",
        confirmDelete: "Verwijderen bevestigen",
        confirmDeleteSelectedTemplate: "Deze sjabloon verwijderen bevestigen",
        push: "Publiceren",
        pushConfirm: "Publiceren naar openbare sjabloon bevestigen",
        pushRemovalConfirm: "Uit de openbare sjabloon verwijderen bevestigen",
        templateOrderRecord: "Sjabloonorderrecord",
        unpublished: "Niet gepubliceerd",
        auditing: "In behandeling",
        publishRejected: "Publicatie afgewezen",
        publishSuccess: "Publiceren succesvol",
        offShelf: "Uit de winkel",
        公共模版: "Openbare sjabloon",
        我的模板: "Mijn sjabloon",
        共享记录: "Delen record",
        name: "Naam",
        pubdate: "Publicatiedatum",
        keySeachTip: "Voer trefwoorden in",
        allGroup: "Alle groepen",
        add: "Toevoegen",
        edit: "Bewerken",
        programName: "Programmanaam",
        selectGroup: "Groep selecteren",
    },
    checkManage: {
        total: "Totaal",
        totalNum: "items",
        operationSuccess: "Bewerking succesvol",
        checkUserLogs: "Goedkeuringsrecord (operator)",
        checkLogs: "Goedkeuringsrecord (goedkeurer)",
        sourceCheck: "Materiaal goedkeuring",
        programCheck: "Programma goedkeuring",
        checkAll: "Alles selecteren",
        auditPass: "Goedgekeurd",
        auditRefuse: "Afgewezen",
        auditPass01: "Goedgekeurd",
        auditRefuse01: "Afgewezen",
        auditRefuse02: "Goedkeuring afwijzen",
        auditor: "Goedkeurer",
        agentUserName: "Uitgever",
        interrogationTime: "Inzendingstijd",
        checkTime: "Goedkeuringstijd",
        checkName: "Goedkeuringsnaam",
        checkType: "Goedkeuringscategorie",
        checkIp: "Inzends-IP-adres",
        checkReason: "Bericht",
        checkStatus: "Bewerkingsinhoud",
        rangePicker: "Goedkeuringsdatum",
        keyWord: "Trefwoord",
        all: "Alles",
        program: 'Programma',
        material: 'Materiaal',
        dan: "Enkel",
        shaung: "Dubbel",
        pleaseSelectProgram: "Selecteer een programma!",
        pleaseSelectMaterial: "Selecteer materiaal！",
        preview: "Voorbeeld",
        dpi: 'Resolutie',
        auditRefuseTip: "Voer de afwijzingsreden in",
        unreviewed: "Niet goedgekeurd",
        notPassed: "Niet goedgekeurd",
        notUsed: "Niet gebruikt",
        edit: "Bewerken",
        none: "Geen",
        name: "Naam",
        size: "Grootte",
        type: "Type",
        uploadTime: "Uploadtijd",
        uploadUser: "Uploader",
        checkUser: "Goedkeurer",
        image: "Afbeelding",
        music: "Muziek",
        video: "Video",
    },
    systemSet: {
        total: "Totaal",
        totalNum: "items",
        inputPlaceholder: 'Voer in',
        selectPlaceholder: 'Selecteer',
        userList: "Organisatieleden",
        roleList: "Rolrechten",
        department: "Organisatiestructuur",
        diskInfo: "Opslagruimte",
        approveSet: "Inhoud goedkeuring",
        logList: "Logboekbeheer",
        name: "Naam",
        account: "Account",
        userName: "Gebruikersnaam",
        phoneNumber: "Telefoonnummer",
        role: "Rol",
        createTime: "Aanmaaktijd",
        operation: "Bewerking",
        edit: "Bewerken",
        delete: "Verwijderen",
        addNew: "Toevoegen",
        add: "Toevoegen",
        resetPassword: "Wachtwoord opnieuw instellen",
        confirmDelete: "Verwijderen bevestigen",
        departmentOrganization: "Afdelingsorganisatie",
        addNewUser: "Nieuwe gebruiker toevoegen",
        pleaseEnterUserName: "Voer de gebruikersnaam in",
        confirmPasswordNotMatch: "Bevestigingswachtwoord komt niet overeen met het ingevoerde wachtwoord!",
        operationSuccess: "Bewerking succesvol！",
        userNickname: "Gebruikersnaam",
        pleaseEnterUserNickname: "Voer de gebruikersnaam in",
        userNicknameRequired: "Gebruikersnaam mag niet leeg zijn！",
        password: "Wachtwoord",
        pleaseEnterPassword: "Voer het wachtwoord in",
        passwordRequired: "Wachtwoord mag niet leeg zijn！",
        passwordTip: "Uw wachtwoord is te onveilig (het wachtwoord moet 3 van de volgende bevatten: hoofdletters, kleine letters, cijfers, speciale tekens en de lengte moet tussen 8 en...",
        confirmPassword: "Wachtwoord bevestigen",
        pleaseEnterPhoneNumber: "Voer het telefoonnummer in",
        phoneNumberRequired: "Telefoonnummer mag niet leeg zijn！",
        phoneNumberFormatError: "Voer een geldig telefoonnummer in！",
        roleRequired: "Rol mag niet leeg zijn！",
        required: "Mag niet leeg zijn！",
        departmentName: "Afdeling",
        modifyPassword: "Wachtwoord wijzigen",
        newPassword: "Nieuw wachtwoord",
        pleaseEnterNewPassword: "Voer het nieuwe wachtwoord in",
        pwdMessage: "Wachtwoordlengte 8~20 tekens, mag geen spaties bevatten en moet 3 van de volgende bevatten: hoofdletters, kleine letters, cijfers, speciale tekens",
        all: "Alles",
        noAuths: "Geen rechten, neem contact op met de beheerder",
        departmentName01: "Afdelingsnaam",
        image: "Afbeelding",
        music: "Muziek",
        video: "Video",
        buySize: "Aantal gekocht",
        totalMoney: "Betaalde bedrag",
        buycreateTime: "Aankooptijd",
        endTime: "Vervaldatum",
        buyTypeStr: "Ordertype",
        sourceCheck: "Materiaal goedkeuring",
        programCheck: "Programma goedkeuring",
        programName: "Programmanaam",
        diskExpansion: "Het wordt aanbevolen om verlopen/ongebruikt materiaal tijdig op te schonen om de beschikbare capaciteit van het systeem te garanderen. Als u meer ruimte nodig heeft, kunt u contact opnemen met uw apparaatleverancier om de capaciteit van de cloudopslagruimte uit te breiden. Deze service kan kosten met zich meebrengen, raadpleeg de informatie van de distributeur voor de exacte kosten.",
        selectPermission: "Selecteer rechten",
        checkPermission: "Rechten aanvinken",
        addRole: "Rol toevoegen",
        enterRoleName: "Voer de rolename in",
        roleName: "Rolnaam",
        roleNameRequired: "Rolnaam mag niet leeg zijn！",
        remark: "Opmerking",
        enterRemark: "Voer een opmerking in",
        permissionSetting: "Rechtiinstellingen",
        deleteSuccess: "Verwijderen succesvol！",
        confirmToDelete: "Verwijderen bevestigen？",
        orgName: "Organisatienaam",
        orgNameRequired: "Organisatienaam mag niet leeg zijn！",
        orgRemark: "Organisatieopmerking",
        enterOrgRemark: "Voer de organisatieopmerking in",
        capacityUsage: "Capaciteitsgebruik",
        usedCapacity: "Gebruikte capaciteit",
        totalCapacity: "Totale capaciteit",
        remainingCapacity: "Resterende capaciteit",
        capacityExpansion: "Capaciteit uitbreiden",
        enable: "Inschakelen",
        disable: "Uitschakelen",
        userName01: "Gebruikersnaam",
        loginTime: "Inlogtijd",
        ipAddress: "IP-adres",
        loginResult: "Inlogresultaat",
        selectDate: "Datum selecteren",
        enterDate: "Selecteer een datum",
        selectStartTime: "Begintijd selecteren",
        selectEndTime: "Eindtijd selecteren",
        enterUserName: "Voer de gebruikersnaam in",
        userCount: "Aantal gebruikers",
        roleDesc: "Rolbeschrijving",
        roleAuthorization: "Rolautorisatie",
        success: "Succes",
        failure: "Mislukt",
        time: "Tijd",
        operationContent: "Bewerkingsinhoud",
        playCount: "Aantal afspeelingen",
        playDuration: "Afspeelduur",
        selectDevice: "Apparaat selecteren",
        enterProgramName: "Voer de programmanaam in",
        serialNumber: "Volgnummer",
        publishContentName: "Naam van gepubliceerde inhoud",
        playMode: "Afspeelwijze",
        cyclePlay: "Doorlopend afspelen",
        insertPlay: "Invoegen afspelen",
        paddingPlay: "Vulling afspelen",
        playDeviceId: "Afspeelapparaat-ID",
        playDeviceName: "Afspeelapparaatnaam",
        publishTime: "Publicatietijd",
        downloadStatus: "Downloadstatus",
        notDownloaded: "Niet gedownload",
        downloading: "Downloaden",
        downloadSucceeded: "Downloaden succesvol",
        downloadFailed: "Downloaden mislukt",
        enterPublishContentName: "Voer de naam van de gepubliceerde inhoud in",
        terminalId: "Terminal-ID",
        belongOrg: "Toegewezen organisatie",
        reportTime: "Rapportagetijd",
        reportIp: "Rapportage-IP",
        logInfo: "Logboekinformatie",
        details: "Details",
        confirmDeletion: "Verwijderen bevestigen？",
        logDetails: "Logboekdetails",
        download: "Downloaden",
        deptOrg: "Afdelingsorganisatie",
        query: "Opvragen",
        queryByTerminalId: "Opvragen per Terminal-ID",
        batchDeleteLogs: "Batch logboeken verwijderen",
        customTimeDeleteLogs: "Logboeken verwijderen op aangepaste tijd",
        selectTimeRangeFirst: "Selecteer eerst een tijdsbereik",
        deleteAllDeviceLogsIfEmpty: "Als geen apparaat-ID is ingevuld, worden standaard de logboeken van alle apparaten verwijderd",
        enterDeviceIdToDeleteLogs: "Voer de apparaat-ID in waarvan de logboeken moeten worden verwijderd",
        confirmDeleteAction: "Verwijderen bevestigen",
        selectDeleteRangeFirst: "Selecteer eerst het verwijderbereik",
        networkConnectionFailed: "Netwerkverbinding mislukt",
        playLog: "Afspeellogboek",
        publishLog: "Publicatielogboek",
        errorLog: "Foutlogboek",
        operationLog: "Bewerkingslogboek",
        fileLog: "Bestandslogboek",
        userOperateLog: "Inloglogboek",
    },
    userManual: {
        userManual: "Gebruikershandleiding",
        noData: "Geen gegevens",
    },
    systemNotice: {
        systemNotice: "Systeemnotificatie",
        noData: "Geen gegevens",
        total: "Totaal",
        totalNum: "items",
        "markAllRead": "Alles als gelezen markeren",
        "deleteAll": "Alles verwijderen",
        "all": "Alles",
        "unread": "Ongelezen",
        "read": "Gelezen",
        "type": "Type",
        "content": "Inhoud",
        "date": "Datum",
        "status": "Status",
        "confirmDelete": "Verwijderen bevestigen？",
        "confirm": "Bevestigen",
        "cancel": "Annuleren",
        "delete": "Verwijderen"
    }
};